import React, { useState, useEffect, useRef } from 'react';
import * as Styled from './VideoPlayerStyled';

const VideoPlayer = ({ url, thumbnail, duration }) => {

  console.log("duration ->",duration)
  const [pause, setPause] = useState(true);
  const [mute, setMute] = useState(false);
  const [fullScr, setFullScr] = useState(false);
  const [controlsBottom, setControlsBottom] = useState('0px');
  const [volumeHeight, setVolumeHeight] = useState('0px');
  const [volume, setVolume] = useState(100);
  const [seek, setSeek] = useState(0);
  const [currentTime, setCurrentTime] = useState('');
  const [screenIconOpacity, setScreenIconOpacity] = useState('1');
  const [videoDuration, setVideoDuration] = useState(0);

  const vidRef = useRef(null);
  const videoRef = useRef(null);
  const controlTimer = useRef(null);
  const controlShowTime = 3000;

  useEffect(() => {
    if (vidRef && vidRef.current) {
      vidRef.current.volume = 1;
      if (thumbnail) {
        vidRef.current.setAttribute('poster', thumbnail);
      }

      if (duration && typeof duration !== 'undefined' && duration !== null) {
        setVideoDuration(duration);
      } else if (vidRef.current.duration) {
        setVideoDuration(vidRef.current.duration);
      }
    }

    return () => {
      console.log("pause >",)
      pauseVideo();
    }
  }, []);

  const onVolumeChange = (e) => {
    if (vidRef && vidRef.current) {
      vidRef.current.volume = e.target.value / 100;
      setVolume(e.target.value);
    }
  };

  const playVideo = () => {
    setPause(false);
    if (vidRef && vidRef.current) {
      vidRef.current.play();
    }

    clearTimeout(controlTimer.current);
    controlTimer.current = null;

    controlTimer.current = setTimeout(() => {
      setControlsBottom('-45px');
      setScreenIconOpacity('0');
    }, controlShowTime);
  };

  const pauseVideo = () => {
    setPause(true);
    if (vidRef && vidRef.current) {
      vidRef.current.pause();
    }

    clearTimeout(controlTimer.current);
    controlTimer.current = null;

    setControlsBottom('0px');
    setScreenIconOpacity('1');
  };

  const showControls = () => {
    setControlsBottom('0px');
    setScreenIconOpacity('1');

    clearTimeout(controlTimer.current);
    controlTimer.current = null;

    controlTimer.current = setTimeout(() => {
      setControlsBottom('-45px');
      setScreenIconOpacity('0');
    }, controlShowTime);
  }

  const hideVolumeBar = () => {
    setVolumeHeight('0px');
  }

  const muteVideo = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.muted === false) {
        setMute(true);
        vidRef.current.muted = true;
      } else {
        setMute(false);
        vidRef.current.muted = false;
      }
    }
  };

  const fullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      setFullScr(false);
    } else if (document.webkitFullscreenElement) {
      document.webkitExitFullscreen();
      setFullScr(false);
    } else if (videoRef && videoRef.current && videoRef.current.webkitRequestFullscreen) {
      videoRef.current.webkitRequestFullscreen();
      setFullScr(true);
    } else if (videoRef && videoRef.current) {
      videoRef.current.requestFullscreen();
      setFullScr(true);
    }
  };

  const seekChange = (e) => {
    if (vidRef && vidRef.current && vidRef.current.currentTime) {
      const vCurrentTime = Math.round(vidRef.current.currentTime);
      const vDuration = Math.round(duration);
      const vTime = Math.round(vDuration * (e.target.value / 100));

      vidRef.current.currentTime = vTime;
      
      setSeek(e.target.value);
      setCurrentTime(vCurrentTime);
    }
  };

  const videoPlaying = () => {
    if (vidRef && vidRef.current && vidRef.current.currentTime) {
      const vDuration = Math.round(duration);
      const vCurrentTime = Math.round(vidRef.current.currentTime);
      const vPercentage = ( vCurrentTime / vDuration ) * 100;

      setSeek(vPercentage);
      setCurrentTime(vCurrentTime);
    }
  }

  const formatTime = (secs) => {
    let time = '';
    if (typeof secs !== 'undefined' && secs !== null) {
      const divisor_for_minutes = secs % (60 * 60);
      
      let hours = Math.floor(secs / (60 * 60));
      let minutes = Math.floor(divisor_for_minutes / 60);
      let seconds = Math.ceil(divisor_for_minutes % 60);
      
      const obj = {
        "h": hours < 10 ? `0${hours} : ` : '',
        "m": `${minutes < 10 ? '0' : ''}${minutes} : `,
        "s": `${seconds < 10 ? '0' : ''}${seconds}`,
      };
      time = `${hours > 0 ? obj.h : ''}${obj.m}${obj.s}`;
    }
    return time;
  }

  return (
    <Styled.videoDiv style={{ marginBottom: '0px' }} ref={videoRef}>
      <video
        ref={vidRef}
        src={url}
        type="video/mp4"
        style={{ width: '100%', margin: '0', padding: '0' }}
        onTimeUpdate={videoPlaying}
      />
      <Styled.onScreenIconDiv>
        { pause ?
          <Styled.ScreenPlayDiv onClick={playVideo} title="Play" >
            <img src="/player-screen-play.svg" />
          </Styled.ScreenPlayDiv>
        :
          <Styled.ScreenPlayDiv onClick={pauseVideo} title="Pause" style={{ opacity: screenIconOpacity }}>
            <img src="/player-screen-pause.svg" />
          </Styled.ScreenPlayDiv>
        }
      </Styled.onScreenIconDiv>

      <Styled.videoOverlayDiv onClick={showControls} />

      <Styled.videoMenuDiv style={{ bottom: controlsBottom }}>
        { pause === true ?
          <Styled.PlayDiv onClick={playVideo} title="Play" >
            <img src="/player-play.svg" />
          </Styled.PlayDiv>
        :
          <Styled.PlayDiv onClick={pauseVideo} title="Pause">
            <img src="/player-pause.svg" />
          </Styled.PlayDiv>
        }

        <Styled.seekProgressDiv>
          <Styled.sliderInput
            type="range"
            id="seek-bar"
            value={seek}
            onChange={seekChange}
          />
          <Styled.seekProgress value={seek} max="100"></Styled.seekProgress>
        </Styled.seekProgressDiv>

        <Styled.TimeDiv>{`${formatTime(duration)} / ${formatTime(currentTime)}`}</Styled.TimeDiv>

        <Styled.muteUnmuteDiv onMouseOver={() => setVolumeHeight('60px')} onMouseOut={hideVolumeBar}>
          <Styled.volumeBarDiv style={{ height: volumeHeight }}>
            <Styled.volumeSliderInput
              type="range"
              id="volume-bar"
              value={volume}
              onChange={onVolumeChange}
            />
            <Styled.volumeProgress value={volume} max="100"></Styled.volumeProgress>
          </Styled.volumeBarDiv>

          <Styled.muteIconBtn onClick={muteVideo}>
            <img src={ mute ? '/player-mute.svg' : '/player-volume.svg' } />
          </Styled.muteIconBtn>
        </Styled.muteUnmuteDiv>

        <Styled.fullScrIconBtn type="button" onClick={fullscreen}>
          { fullScr ?
            <img src="/player-exit-fullscreen.svg" />
          : 
            <img src="/player-fullscreen.svg" />
          }
        </Styled.fullScrIconBtn>

      </Styled.videoMenuDiv>
      <Styled.hoverAllDiv>
      </Styled.hoverAllDiv>
    </Styled.videoDiv>
  )
}
export default VideoPlayer;